import { render, staticRenderFns } from "./IndexDashboard.vue?vue&type=template&id=92302066&"
import script from "./IndexDashboard.vue?vue&type=script&lang=js&"
export * from "./IndexDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports